//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
  fileImmigrationDocket,
} from "@/services/constants";
import DateField from "./DateField.vue";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import SuccessDialogPushpaymentIM from "@/components/cards/SuccessDialogPushpaymentIM";
import TimeLineOperations from "../timeline/TimeLineOperations.vue"; // ⭐ เพิ่มใหม่
import InvoiceSectionPanel from "../payment-invoice/InvoiceSectionPanel.vue";
import PDFCaseProgress from "@/utils/pdfClientTimeLine"; // ⭐ เพิ่มใหม่
const moment = require("moment-timezone"); // ⭐ เพิ่มใหม่

/* ---------- date helpers (DD/MM/YYYY <-> ISO) ---------- */
const pad = (n) => (n < 10 ? "0" : "") + n;
const dmyToISO = (d) => {
  if (!d) return "";
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(d).trim());
  return m ? `${m[3]}-${m[2]}-${m[1]}` : "";
};
const isoToDMY = (iso) => {
  if (!iso) return "";
  const p = String(iso).split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : "";
};
const addDaysDMY = (d, days) => {
  const iso = dmyToISO(d);
  if (!iso) return "";
  const dt = new Date(`${iso}T00:00:00`);
  dt.setDate(dt.getDate() + days);
  return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()}`;
};
const dmyDates = (obj) => {
  const out = {};
  Object.keys(obj || {}).forEach((k) => {
    out[k] = /date$/i.test(k) ? isoToDMY(obj[k]) : obj[k];
  });
  return out;
};

/* ---------- work type config ---------- */
const WORK_TYPE_CONFIG = {
  "visa-renewal": { blocks: ["visa"] },
  "visa-cancel": { blocks: ["visa", "cancel"], cancelLabel: "Visa Cancellation" },
  "wp-new": { blocks: ["wp"] },
  "wp-renewal": { blocks: ["wp"] },
  "wp-cancel": { blocks: ["wp", "cancel"], cancelLabel: "Work Permit Cancellation" },
  "wp-urgent": { blocks: ["wp"], urgent: true },
  "wp-urgent-new": { blocks: ["wp"], urgent: true },
  "vwp-renewal": { blocks: ["visa", "wp"] },
  "ltr-new": { blocks: ["ltr", "wp"] },
  "ltr-renewal": { blocks: ["ltr", "wp"] },
  "ltr-cancel": { blocks: ["ltr", "wp", "cancel"], cancelLabel: "LTR Cancellation" },
  pcc: { blocks: ["simple"], simpleLabel: "Police Clearance Certificate | ใบรับรองความประพฤติ" },
  legal: { blocks: ["simple"], simpleLabel: "Legalization | รับรองเอกสาร" },
  notarial: { blocks: ["simple"], simpleLabel: "Notarial Services | รับรองลายมือชื่อ/เอกสาร" },
  "90day": { blocks: ["report"], reportDays: 90 },
  annual: { blocks: ["report"], reportDays: 365 },
  toe: { blocks: ["toe"] },
  tax: { blocks: ["tax"] },
  other: { blocks: ["simple"], simpleLabel: "Other Immigration Service | งานบริการอื่น ๆ" },
};
const WT_LABELS = {
  "visa-renewal": "Visa Renewal | ต่ออายุ", "visa-cancel": "Visa Cancellation | ยกเลิกวีซ่า",
  "wp-new": "New Work Permit | ใบอนุญาตทำงานใหม่", "wp-renewal": "Work Permit Renewal | ต่ออายุ",
  "wp-cancel": "Work Permit Cancellation | ยกเลิก", "wp-urgent": "Urgent Work Permit Extension | ขยายเร่งด่วน",
  "wp-urgent-new": "Urgent Work Permit | ใบอนุญาตทำงานเร่งด่วน",
  "vwp-renewal": "Visa & Work Permit Renewal | ต่ออายุ", "ltr-new": "New LTR | วีซ่าพำนักระยะยาวใหม่",
  "ltr-renewal": "LTR Renewal | ต่ออายุ", "ltr-cancel": "LTR Cancellation | ยกเลิก",
  pcc: "Police Clearance Certificate", legal: "Legalization | รับรองเอกสาร", notarial: "Notarial Services",
  "90day": "90-Day Report | รายงานตัว 90 วัน", annual: "Annual Report | รายงานตัวประจำปี",
  toe: "Transfer of Endorsement | โอนตราประทับวีซ่า", tax: "Personal Income Tax Filing | ยื่นแบบภาษีเงินได้",
  other: "Other Immigration Service | งานบริการอื่น ๆ",
};
const HAS_APPLICANTS = ["visa-renewal", "visa-cancel", "vwp-renewal", "ltr-new", "ltr-renewal", "ltr-cancel"];
const NO_CASE_TYPE = ["pcc", "legal", "notarial", "90day", "annual", "toe", "tax", "other"];
const WORK_TYPE_ITEMS = [
  { header: "Visa" },
  { text: "Visa Renewal | ต่ออายุ", value: "visa-renewal" },
  { text: "Visa Cancellation | ยกเลิกวีซ่า", value: "visa-cancel" },
  { divider: true }, { header: "Work Permit" },
  { text: "New Work Permit | ใบอนุญาตทำงานใหม่", value: "wp-new" },
  { text: "Work Permit Renewal | ต่ออายุ", value: "wp-renewal" },
  { text: "Work Permit Cancellation | ยกเลิก", value: "wp-cancel" },
  { text: "Urgent Work Permit | ใบอนุญาตทำงานเร่งด่วน", value: "wp-urgent-new" },
  { text: "Urgent Work Permit Extension | ขยายเร่งด่วน", value: "wp-urgent" },
  { divider: true }, { header: "Visa + Work Permit" },
  { text: "Visa & Work Permit Renewal | ต่ออายุ", value: "vwp-renewal" },
  { divider: true }, { header: "LTR" },
  { text: "New LTR | วีซ่าพำนักระยะยาวใหม่", value: "ltr-new" },
  { text: "LTR Renewal | ต่ออายุ", value: "ltr-renewal" },
  { text: "LTR Cancellation | ยกเลิก", value: "ltr-cancel" },
  { divider: true }, { header: "Documents & Reports" },
  { text: "Police Clearance Certificate | ใบรับรองความประพฤติ", value: "pcc" },
  { text: "Legalization | รับรองเอกสาร", value: "legal" },
  { text: "Notarial Services | รับรองลายมือชื่อ/เอกสาร", value: "notarial" },
  { text: "90-Day Report | รายงานตัว 90 วัน", value: "90day" },
  { text: "Annual Report | รายงานตัวประจำปี", value: "annual" },
  { text: "Transfer of Endorsement | โอนตราประทับวีซ่า", value: "toe" },
  { text: "Personal Income Tax Filing | ยื่นแบบภาษีเงินได้", value: "tax" },
  { text: "Other Immigration Service | งานบริการอื่น ๆ", value: "other" },
];

const blankApplicant = () => ({
  relation: "Family/Dependant | Non-O", name: "", nationality: "", visaType: "",
  visaIssue: "", visaExpiry: "", status: "active", submissionDate: "", effectiveDate: "",
});
const blankForm = () => ({
  workType: "", passport: "", fileNo: null, principalApplicant: "", clientName: "", hostCompany: "",
  nationality: "", globalCaseNo: "", caseType: "", remark: "", status: "Ongoing | ดำเนินการอยู่",
  worker: null, subWorker: [],
  visa: { type: "", issueDate: "", placeOfIssue: "", expiryDate: "" },
  wp: { alienId: "", number: "", issueDate: "", placeOfIssue: "", expiryDate: "" },
  ltr: { category: "", reference: "", issueDate: "", expiryDate: "" },
  cancel: { submissionDate: "", effectiveDate: "" },
  report: { applicationDate: "", dueDate: "", track: "yes" },
  toe: { newPassport: "", issueDate: "" },
  tax: { taxType: "", taxId: "", incomeType: "", calendarYear: "", filingDate: "", issuanceDate: "" },
  simple: { issueDate: "" },
});

export default {
  name: "NewImmigrationDocket",
  components: {
    DateField,
    SuccessDialog,
    SuccessDialogPush,
    SuccessDialogPushpaymentIM,
    TimeLineOperations, // ⭐ เพิ่มใหม่
    InvoiceSectionPanel
  },
  data: () => ({
    worker_list: [],
    case_type_list: [],
    visa_type_list: [],
    filename: [],          // ชื่อไฟล์ที่แสดง
    image_list: [],        // File objects จริง → ใช้ append FormData
    getpreview_list: [],   // dataURL สำหรับ preview
    dialogDeletefile: false,
    indexdelete: -1,
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    link: "",
    workTypeItems: WORK_TYPE_ITEMS,
    customer_name_list: [],
    nationality_list: [],
    caseTypes: [
      "NON-BOI | วีซ่าและใบอนุญาตทำงาน", "BOI | ภายใต้การส่งเสริมการลงทุน",
      "IEAT | ภายใต้การนิคมอุตสาหกรรม", "DMF | ภายใต้กรมการเชื้อเพลิงธรรมชาติ", "MEDIA | สื่อมวลชน",
    ],
    visaTypes: [
      { text: "Business/Work | Non-B", value: 1 },
      { text: "Family/Dependant | Non-O", value: 2 },
      { text: "LTR Entry", value: 3 },
      { text: "Smart Visa T", value: 4 },
    ],
    place_of_issue_list: [],
    work_place_of_issue_list: [],
    ltrCategories: ["Wealthy Global Citizens", "Wealthy Pensioners", "Work-From-Thailand Professionals", "Highly-Skilled Professionals", "Dependants of the above categories"],
    relations: ["Family/Dependant | Non-O", "Spouse", "Child", "Parent"],
    applicantStatus: [{ text: "Active | ยังมีผลใช้งาน", value: "active" }, { text: "Cancelled | ยกเลิก", value: "cancelled" }],
    statuses: ["Ongoing | ดำเนินการอยู่", "Complete | ดำเนินการเสร็จสิ้น", "Request Payment"],
    taxTypes: ["ภ.ง.ด. 90", "ภ.ง.ด. 91", "ภ.ง.ด. 95"],
    incomeTypes: ["เงินเดือน", "ธุรกิจ", "รายได้อื่น ๆ"],
    docTypes: [
      "Passport (ID Page) | หน้าข้อมูล", "Visa Page | หน้าวีซ่า", "90-Day Report | รายงาน 90 วัน",
      "Marriage Cert. | ใบสมรส", "Birth Cert. | สูติบัตร", "Degree Cert. | ปริญญาบัตร", "Others | อื่น ๆ",
    ],
    fileno_list: [],
    form: blankForm(),
    applicants: [],
    // applicants: [blankApplicant()],
    docModal: false,
    docSelected: [],
    uploadedDocs: [],
    snackbar: { show: false, text: "", color: "success" },
    customer_id: 0,
    isEdit: false,
    docketId: null,
    oldFiles: [],

    // ⭐ เพิ่มใหม่ทั้งหมด — สำหรับ Internal Timeline tab (ตามแบบหน้า Add)
    // module_name เป็น "Immigration" — modeOperations เป็น "Edit" เพราะ
    // docketId มีอยู่แล้วตั้งแต่เปิดหน้า (มาจาก route param) ทำให้
    // TimeLineOperations โหลดประวัติ timeline เดิมมาแสดงได้เลย
    // pageLoading ใช้กันไม่ให้แท็บ Timeline mount ก่อน docketId พร้อม
    pageLoading: true,
    tabselect: 0,
    timelineStatus: 0,
    status_note: "",
    visible_check: false,
    dialogDelete: false,
    timeline_case_id: 0,
    module_name: "Immigration",
    modeOperations: "Edit",
    reportlist: [],
    statuslist: [],
    //quotations
    formQutations: {
      salesOrderId: 0,
      price: 0,
      customerName: "",
      currency: "",
    },
    salesOrderList: [],
    invoiceList: [],
    // invoiceMenu: false,
    // invoiceMenuPay: false,
    invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],
    quotationscheckstatus: '',
    querydata: '',
  }),

  computed: {
    cfg() { return this.form.workType ? WORK_TYPE_CONFIG[this.form.workType] : null; },
    wtLabel() { return WT_LABELS[this.form.workType] || this.form.workType; },
    showCaseType() { return !NO_CASE_TYPE.includes(this.form.workType); },
    showApplicants() { return HAS_APPLICANTS.includes(this.form.workType); },
    requestPaymentDisabled() {
      const price = Number(this.formQutations.price);
      const salesOrderId = Number(this.formQutations.salesOrderId);
      const customerId = Number(this.customer_id);

      const isPriceValid = !isNaN(price) && price > 0;
      const isSalesOrderIdValid = !isNaN(salesOrderId) && salesOrderId > 0;
      const isCustomerIdValid = !isNaN(customerId) && customerId > 0;

      return !(isPriceValid && isSalesOrderIdValid && isCustomerIdValid);
    },
  },

  /* ===== reused from old file (only mounted / data load) ===== */
  async mounted() {
    await this.loadCustomer();
    await this.loadnationality();
    await this.loadplace_of_issue_list();
    await this.loadwork_place_of_issue_list();
    await this.loadvisa_types();
    await this.loadcase_type_list();
    await this.loaddataSalesOrder();
    await this.loadWorker();
    await this.loadfileno_list();
    // await this.loaddatafile_no();
    if (this.$route.params.id) {
      this.isEdit = true;
      this.docketId = this.$route.params.id;
      await this.loaddataEdit();

    } else {
      await this.loaddatafile_no();
    }

    // ⭐ เพิ่ม — โหลด statuslist สำหรับ module "Immigration" แล้วซิงค์
    // timelineStatus เริ่มต้นตาม form.status ปัจจุบันของ docket (เดิม ไม่แตะ
    // ส่วนอื่นของ mounted() เลย)
    await this.loaddataImmigrationStatus();
    this.timeline_case_id = Number(this.docketId);
    this.sendToStatus(this.form.status);
    this.pageLoading = false;
    await this.loadDataInvoice(this.$route.params.id);
    this.$hideLoader();
  },
  beforeCreate() {
    //console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },

  methods: {
    toArray(v) {
      let val = v;
      for (let i = 0; i < 3 && typeof val === "string"; i++) {
        try {
          val = JSON.parse(val);
        } catch (e) {
          return [];
        }
      }
      return Array.isArray(val) ? val : [];
    },
     async loadWorker() {
      const result = await api.getAccountsByCompanyImmogration(
        localStorage.getItem(server.COMPANYID)
      );
      this.worker_list = result.data;
    },
     async loadcase_type_list() {
      const result = await api.getImCaseTypeByCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
          department_id: localStorage.getItem(server.DEPARTMENT_ID),
        },
      });
      this.case_type_list = result.data;
    },
     async loadvisa_types() {
      const result = await api.getAll_visa_types(
        localStorage.getItem(server.COMPANYID)
      );
      const list = [];
      let currentGroup = null;
      (result.data || []).forEach((row) => {
        if (row.group_name !== currentGroup) {
          if (currentGroup !== null) list.push({ divider: true });
          list.push({ header: row.group_name });
          currentGroup = row.group_name;
        }
        list.push({ id: row.id, title: row.title, value: row.code });
      });
      this.visa_type_list = list;
    },
     async loadplace_of_issue_list() {
      const result = await api.getImMasterPlaceofissueByCompany_Dep({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
          department_id: localStorage.getItem(server.DEPARTMENT_ID),
        },
      });
      this.place_of_issue_list = result.data;
    },
    async loadwork_place_of_issue_list() {
      const result = await api.getImMasterWorkPlaceofissueByCompany_Dep({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
          department_id: localStorage.getItem(server.DEPARTMENT_ID),
        },
      });
      this.work_place_of_issue_list = result.data;
    },
      async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.customer_name_list = result.data;
    },
        async loadnationality() {
      const result = await api.getAll_im_nationality();
      this.nationality_list = result.data;
    },
    //quotations 
    async loaddataSalesOrder() {
      try {
        const res = await api.getQuotatinsForDocketCore(Number(localStorage.getItem(server.COMPANYID)));
        this.salesOrderList = res.data || [];

      } catch (error) {
        console.error("loaddataSalesOrder error:", error);
      }
    },
    onSelectSO(so) {
      // component ส่ง object ของ quotation ที่เลือกมาให้แล้ว (หรือ null ถ้าเคลียร์ค่า)
      if (!so) {
        this.formQutations.price = "";
        this.formQutations.customerName = "";
        this.formQutations.currency = "";
        this.quotationscheckstatus = "";
        return;
      }
      this.quotationscheckstatus = so.status;
      this.formQutations.price = Number(so.subtotal);
      this.formQutations.customerName = so.customer_name || "";
      this.formQutations.currency = so.currency || "";
    },
    //end quotattions
    previewInvoice(item) {
      const routeData = this.$router.resolve(
        `/edit-invoice/${item.inv_id_preview}/inv_h/edit`
      );
      window.open(routeData.href, '_blank');
    },
    async loadDataInvoice(id) {
      try {
        var dataserach = {
          module_name: 'Immigration',
          module_id: id,
          company_id: Number(localStorage.getItem(server.COMPANYID)),
        }
        const res = await api.getQuotatinsinvoiceListCore({
          params: dataserach
        })
        this.invoiceList = res.data.data || [];
       
      } catch (error) {
        console.error("loadDataInvoice error:", error);
      }
    },
    // ⭐ เพิ่มใหม่ทั้งบล็อกนี้ — สำหรับ Internal Timeline (ก็อปแบบมาจาก
    // หน้า Add) module_name = "Immigration"
    closeDelete() {
      this.dialogDelete = false;
    },
    deleteItemConfirm() {
      this.tabselect = 1;
      this.dialogDelete = false;
    },
    handleRequestStatus(value) {
      this.form.status = value
    },
    sendToStatus(value) {
      const selectedItem = this.statuslist.find(
        (item) => item.module_id === value
      );
      if (selectedItem) {
        this.timelineStatus = Number(selectedItem.timeline_status_id);
      }
    },
    async loaddataImmigrationStatus() {
      try {
        const result = await api.getClientTimelineStatusCongFigByModule(
          "Immigration"
        );
        this.statuslist = (result.data || []).map((item) => ({
          ...item,
          module_id: item.module_id,
        }));
      } catch (error) {
        console.error("Error loading Immigration status config:", error);
      }
    },
    // ⭐ จบบล็อกเพิ่มใหม่สำหรับ Timeline

    async loaddataEdit() {
      const result = await api.getdataByIdim_docket(this.docketId);
      const d = result.data[0] || result.data;   // แล้วแต่ API คืน array หรือ object

      // ---- ฟิลด์หลัก (DB ISO → form) ----
      this.form.workType = d.work_type;
      this.form.passport = d.passport || "";
      this.form.fileNo = d.file_no || null;
      this.form.principalApplicant = d.principal_applicant || "";
      this.form.clientName = d.client_name || "";
      this.form.hostCompany = d.company_name || "";
      this.form.nationality = Number(d.nationality) || "";
      this.form.globalCaseNo = d.global_case_no || "";
      this.form.caseType = d.case_type || "";

      // ---- Case Worker / Sub Case Worker ----
      const w = this.worker_list.find((x) => String(x.id) === String(d.worker));
      this.form.worker = w ? w.id : null;
      const subs = this.toArray(d.sub_worker).map(String);
      this.form.subWorker = this.worker_list
        .filter((x) => subs.includes(String(x.id)))
        .map((x) => x.id);
      this.form.remark = d.remark || "";
      this.form.status = d.status || "Ongoing | ดำเนินการอยู่";
      this.customer_id = d.customer_id || 0;
      this.formQutations.salesOrderId = d.quotations_id || 0;
      // ค้น object เองตอนโหลดข้อมูลเดิม เพราะไม่ได้ผ่าน event จาก component
      const so = this.salesOrderList.find(
        (item) => Number(item.quotation_id) === Number(this.formQutations.salesOrderId)
      );
      this.onSelectSO(so || null);

      // ---- details jsonb → form blocks (แปลงวันที่กลับเป็น DD/MM/YYYY) ----
      const details = typeof d.details === "string" ? JSON.parse(d.details || "{}") : (d.details || {});
      ["visa", "wp", "ltr", "cancel", "report", "toe", "tax", "simple"].forEach((b) => {
        if (details[b]) this.form[b] = { ...this.form[b], ...dmyDates(details[b]) };
      });

      // ---- participants (ตารางลูก) ----
      const participants = typeof d.participants === "string"
        ? JSON.parse(d.participants || "[]")
        : (d.participants || []);
      if (participants.length > 0) {
        this.applicants = participants.map((p) => ({
          relation: p.type,
          name: p.name,
          nationality: p.nationality,
          visaType: p.visa_type,
          visaIssue: isoToDMY(p.visa_issue ? String(p.visa_issue).split("T")[0] : ""),
          visaExpiry: isoToDMY(p.visa_expire ? String(p.visa_expire).split("T")[0] : ""),
          status: p.status || "active",
          submissionDate: "",
          effectiveDate: "",
        }));
      }

      // ---- ไฟล์เดิม (pattern เดียวกับหน้า edit เก่า) ----
      if (d.im_file) {
        this.oldFiles = d.im_file.split(",").filter(Boolean);
        this.filename = [...this.oldFiles];
        this.oldFiles.forEach((name) => {
          // preview ชี้ URL บน server แทน dataURL
          this.getpreview_list.push(
            `${fileImmigrationDocket}/${this.docketId}/${name}`
          );
        });
      }
    },
    async previewMultiImage(event) {
      const input = event.target;
      if (!input.files || input.files.length === 0) return;

      const files = Array.from(input.files);

      const promises = files.map((file) => {
        return new Promise((resolve) => {
          if (file.type === "application/pdf") {
            // กันชื่อซ้ำ: name.pdf → name-1.pdf, name-2.pdf ...
            let originalName = file.name || "file";
            let name = originalName;
            let counter = 1;
            while (this.filename.includes(name)) {
              const dotIndex = originalName.lastIndexOf(".");
              name = dotIndex !== -1
                ? `${originalName.substring(0, dotIndex)}-${counter}${originalName.substring(dotIndex)}`
                : `${originalName}-${counter}`;
              counter++;
            }
            const renamedFile = new File([file], name, { type: file.type });

            this.filename.push(name);
            this.image_list.push(renamedFile);

            const reader = new FileReader();
            reader.onload = (e) => {
              this.getpreview_list.push(e.target.result);
              resolve();
            };
            reader.readAsDataURL(renamedFile);
          } else {
            this.notify("รองรับเฉพาะไฟล์ .pdf เท่านั้น", "error");
            resolve();
          }
        });
      });

      await Promise.all(promises);
      input.value = ""; // เคลียร์ input ให้เลือกไฟล์เดิมซ้ำได้
    },

    popuppreviewfile(index) {
      const pdf_newTab = window.open("");
      pdf_newTab.document.write(
        "<html><head><title>pdf file</title></head><body>" +
        "<iframe width='100%' height='100%' src='" +
        this.getpreview_list[index] +
        "'></iframe></body></html>"
      );
    },

    popupdeletefile(index) {
      this.indexdelete = index;
      this.dialogDeletefile = true;
    },
    closeDeletefile() {
      this.indexdelete = -1;
      this.dialogDeletefile = false;
    },
    deleteItemConfirmfile() {
      const name = this.filename[this.indexdelete];

      // ถ้าเป็นไฟล์เก่า → เอาออกจาก oldFiles (backend จะรู้จาก im_file ที่ส่งกลับไปว่าเหลือไฟล์ไหน)
      const oldIdx = this.oldFiles.indexOf(name);
      if (oldIdx !== -1) this.oldFiles.splice(oldIdx, 1);

      // ถ้าเป็นไฟล์ใหม่ → เอา File object ออกด้วย
      const newIdx = this.image_list.findIndex((f) => f.name === name);
      if (newIdx !== -1) this.image_list.splice(newIdx, 1);

      this.filename.splice(this.indexdelete, 1);
      this.getpreview_list.splice(this.indexdelete, 1);
      this.closeDeletefile();
    },
    async setupAlertDialogPushpaymentIM(
      status,
      title,
      message,
      text_color,
      link,
      querydata
    ) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
      this.querydata = querydata;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async loadfileno_list() {
      const result = await api.getfile_numberim_principal_Company({
        params: { company_id: localStorage.getItem(server.COMPANYID) },
      });
      this.fileno_list = result.data;
    },
    async loaddatafile_no() {
      const routeFile = this.$route && this.$route.params ? this.$route.params.file_no : null;
      if (!routeFile) return;
      const x = this.fileno_list.find((f) => f.file_number == routeFile);
      if (x) { this.form.fileNo = x.id; this.onFileNoChange(x.id); }
    },
     onFileNoChange(id) {
      const x = this.fileno_list.find((f) => f.id === id);
      if (!x) return;

      const c = this.customer_name_list.find(
        (c) => String(c.id) === String(x.customer_id) || c.name === x.customer_name
      );
      if (c) {
        this.form.clientName = c.id;
        this.customer_id = c.id;
      } else {
        this.customer_id = x.customer_id || 0;
      }

      this.form.hostCompany = x.company_name || "";
      this.form.principalApplicant = x.client_name || this.form.principalApplicant;
    },
    onWorkTypeChange() {
      this.recalcDue();
      // if (this.showApplicants && this.applicants.length === 0) this.applicants = [blankApplicant()];
    },
    recalcDue() {
      this.form.report.dueDate =
        this.cfg && this.cfg.reportDays && this.form.report.applicationDate
          ? addDaysDMY(this.form.report.applicationDate, this.cfg.reportDays)
          : "";
    },
    addApplicant() { this.applicants.push(blankApplicant()); },
    removeApplicant(i) { this.applicants.splice(i, 1); },
    confirmUpload() {
      const docs = this.docSelected.map((d) => d.split(" | ")[0]);
      this.uploadedDocs = this.uploadedDocs.concat(docs);
      this.docSelected = [];
      this.docModal = false;
      this.notify(`อัปโหลดเอกสาร ${docs.length} รายการ`, "success");
    },
    notify(text, color = "success") { this.snackbar = { show: true, text, color }; },
    goBack() { if (this.$router) this.$router.push("/immigration-docket"); },
    async save(mode) {
      //    if (!this.form.workType) {
      //     this.$store.state.global_dialog = true;
      //           this.setupAlertDialog(
      //             true,
      //             "Failed",
      //             "Please select Work Type",
      //             "text-h5 red--text text-center"
      //           );
      //           return;
      //     }
      //     if (!this.form.passport) {
      // this.$store.state.global_dialog = true;
      //           this.setupAlertDialog(
      //             true,
      //             "Failed",
      //             "Please select Passport",
      //             "text-h5 red--text text-center"
      //           );
      //           return;
      //   }
      const err = this.validateForm();
      if (err) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Failed", err, "text-h5 red--text text-center");
        return;
      }
      // ✅ ตรวจว่าลูกค้าใน Quotation ตรงกับลูกค้าที่ผูกกับแฟ้ม (File No.) นี้
      if (this.formQutations.salesOrderId) {
        const selectedSO = this.salesOrderList.find(
          (item) => Number(item.quotation_id) === Number(this.formQutations.salesOrderId)
        );

        if (!selectedSO) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "ไม่พบใบเสนอราคาที่เลือก กรุณาเลือกใหม่อีกครั้ง",
            "text-h5 red--text text-center"
          );
          return;
        }

        const soClient = Number(selectedSO.client_id);
        const matched =
        soClient === Number(this.form.clientName) ||
        soClient === Number(this.customer_id);

        if (!matched) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ข้อมูลลูกค้าไม่ตรงกัน",
            `ใบเสนอราคา ${selectedSO.doc_no} เป็นของลูกค้า "${selectedSO.customer_name || "-"}" ซึ่งไม่ตรงกับลูกค้าในแฟ้มนี้ กรุณาเลือกใหม่ให้ถูกต้อง`,
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      if (this.timelineStatus == 0 || this.status_note.trim() == "") {
        this.dialogDelete = true;
        return;
      }



      const isoDates = (obj) => {
        const out = {};
        Object.keys(obj).forEach((k) => {
          out[k] = /date$/i.test(k) ? (dmyToISO(obj[k]) || null) : obj[k];
        });
        return out;
      };

      // ---- รวม details ตาม blocks ของ work type ----
      const details = this.cfg
        ? this.cfg.blocks.reduce((a, b) => {
          if (this.form[b]) a[b] = isoDates(this.form[b]);
          return a;
        }, {})
        : {};

      const formData = new FormData();

      // ไฟล์
      this.image_list.forEach((f) => formData.append("file", f));
      formData.append("im_file", this.filename.join(",").replace(/\s/g, "_"));

      // ===== key ตรงชื่อคอลัมน์ im_docket =====
      formData.append("work_type", this.form.workType);
      formData.append("file_no", this.form.fileNo || 0);
      formData.append("client_name", this.form.clientName);
      formData.append("customer_id", this.customer_id || 0);       // ได้จาก onFileNoChange (ดูข้อ 3)
      formData.append("company_name", this.form.hostCompany);
      formData.append("passport", this.form.passport);
      formData.append("principal_applicant", this.form.principalApplicant);
      formData.append("nationality", this.form.nationality);
      formData.append("global_case_no", this.form.globalCaseNo);
      formData.append("case_type", this.showCaseType ? this.form.caseType : "");
      formData.append("worker", this.form.worker || "");
      formData.append("sub_worker", JSON.stringify(this.form.subWorker || []));
      formData.append("status", this.form.status);
      formData.append("remark", this.form.remark);
      formData.append("details", JSON.stringify(details));         // → คอลัมน์ jsonb

      // คอลัมน์ date เดิม — ดึงจาก block ที่เกี่ยวข้อง
      // const visaissueDate = dmyToISO(this.form.visa.issueDate);
      const visaExp = dmyToISO(this.form.visa.expiryDate);
      const workExp = dmyToISO(this.form.wp.expiryDate) || dmyToISO(this.form.ltr.expiryDate);
      const dueDate = dmyToISO(this.form.report.dueDate);
      // if (visaissueDate) formData.append("visa_issue_date", visaissueDate);
      if (visaExp) formData.append("visa_expire_date", visaExp);
      if (workExp) formData.append("work_expire_date", workExp);
      if (dueDate) formData.append("due_date", dueDate);

      formData.append("company_id", localStorage.getItem(server.COMPANYID));
      formData.append("user_create", localStorage.getItem(server.USER_ID));
      formData.append("user_update", localStorage.getItem(server.USER_ID));
      formData.append("flag", this.form.status === "Request Payment" ? 1 : 0);
      formData.append("quotations_id", this.formQutations.salesOrderId);
      // applicants → ตารางลูก im_participant / im_docket_dependent (backend จัดการหลังได้ id)
      const participants = this.showApplicants
        ? this.applicants.filter(ap => ap.name).map(ap => ({
          type: ap.relation, name: ap.name, nationality: ap.nationality,
          visa_type: ap.visaType,
          visa_issue: dmyToISO(ap.visaIssue) || null,
          visa_expire: dmyToISO(ap.visaExpiry) || null,
          status: ap.status,
        }))
        : [];
      formData.append("participants", JSON.stringify(participants));
      this.$showLoader()
      const result = await api.updateim_docket(this.docketId, formData);

      if (result.status === 200 || result.status === 201) {
        // ⭐ เพิ่ม — sync สถานะ quotation กลับเป็น InProgress ถ้ายังเป็น Submitted (copy จาก add.vue)
        try {
          if (this.quotationscheckstatus == "Submitted") {

            var dataupdateStatus = {
              status: "InProgress"
            }
            await api.updateQuotationsCore(Number(this.formQutations.salesOrderId), dataupdateStatus)
          }
        } catch (quotationsError) {
          console.log(quotationsError)
        }

        // ⭐ เพิ่ม — บันทึก timeline history record ใหม่ ผูกกับ docketId เดิม
        // (มีอยู่แล้วตั้งแต่เปิดหน้า Edit ไม่ต้องรอ id เหมือนหน้า Add) ก็อปแบบ
        // มาจาก save() ของหน้า Add แล้วสลับ main_id → this.docketId
        var dataadd_timeline = {
          timeline_status_id: Number(this.timelineStatus),
          case_id: Number(this.docketId),
          module_name: "Immigration",
          case_woker: Number(localStorage.getItem(server.USER_ID)),
          status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
          status_note: this.status_note.trim(),
          visibility: this.visible_check,
        }
        await api.creategetClientTimelineHistory(dataadd_timeline)
        try {
          const caseDetailResult = await api.getgetTimelineDataDetail({
            params: { module_name: this.module_name, case_id: Number(this.docketId) },
          });
          const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

          const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility({
            params: { module_name: this.module_name, case_id: Number(this.docketId) },
          });
          const timelineData = visibilityResult.data || [];

          caseInfo.status = timelineData[0]?.status || '';
          caseInfo.lastUpdated = timelineData[0]?.status_time || '';

          const latestUpdate = {
            message: timelineData[0]?.status_note || '',
            date: timelineData[0]?.status_time || '',
          };

          await PDFCaseProgress.createToPDF(
            {
              caseInfo,
              latestUpdate,
              timelineData,
              caseId: Number(this.docketId),
              moduleName: this.module_name,
            },
            { open: false }
          );
        } catch (pdfError) {
          await this.$hideLoader()
          console.error("PDF generation/upload failed:", pdfError);
          // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึก docket เดิม
        }
        await this.$hideLoader()
        if (mode == "Save") {
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true, "save data", "save data success",
            "text-h5 green--text text-center", "/immigration-docket"
          );
          return;
        } else {
          var selectedModuleIds = [];
          // กรณี array อยู่แล้ว (เช่นมาจาก this.selectedModuleIds หรือ props ที่เป็น array)
          var moduleIds = Array.isArray(selectedModuleIds)
            ? [...selectedModuleIds]
            : [];

          // ยัด mainid เข้าไปในลิสต์ด้วย
          moduleIds.push(this.$route.params.id);

          var dataPush = {
            customer_name_master: this.form.principalApplicant,
            module_id: moduleIds.join(","), // ส่งเป็น "1,2,3,99999"
            quotation_id: Number(this.formQutations.salesOrderId),
          }

          this.$router.push({
            path: `/new-free-invoice/0/invoice/D/${this.customer_id}/Immigration`,
            query: dataPush,
          });
        }
      } else {
        await this.$hideLoader()
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true, "save data", "can't save data",
          "text-h5 red--text text-center"
        );
        return;
      }

      this.notify(`บันทึก Docket สำเร็จ — ${this.wtLabel}`, "success");
    },
    validateForm() {
      const f = this.form;

      // ===== ฟิลด์หลัก (บังคับทุก work type) =====
      if (!f.workType) return "Please select Work Type | กรุณาเลือกประเภทงาน";
      if (!f.passport) return "Please enter Passport | กรุณากรอกเลขหนังสือเดินทาง";
      if (!f.principalApplicant) return "Please enter Principal Applicant | กรุณากรอกชื่อผู้ยื่นคำขอหลัก";
      if (!f.clientName) return "Please select Client Name | กรุณาเลือกผู้ว่าจ้าง";
      if (!f.nationality) return "Please select Nationality | กรุณาเลือกสัญชาติ";
      if (this.showCaseType && !f.caseType) return "Please select Case Type | กรุณาเลือกประเภทเคส";
      if (!f.status) return "Please select Status | กรุณาเลือกสถานะ";

      // ===== ฟิลด์ตาม block ของ work type ที่เลือก =====
      const blocks = this.cfg ? this.cfg.blocks : [];

      if (blocks.includes("wp")) {
        if (!f.wp.alienId) return "Please enter Alien ID | กรุณากรอกเลขคนต่างด้าว";
        if (!/^\d{13}$/.test(f.wp.alienId))
          return "Alien ID must be 13 digits | เลขคนต่างด้าวต้องเป็นตัวเลข 13 หลัก";
      }

      if (blocks.includes("report") && !f.report.applicationDate)
        return "Please enter Application Date | กรุณากรอกวันที่ยื่น";

      if (blocks.includes("toe")) {
        if (!f.toe.newPassport) return "Please enter New Passport | กรุณากรอกเลขหนังสือเดินทางใหม่";
        if (!f.toe.issueDate) return "Please enter Issue Date | กรุณากรอกวันที่ออกเอกสาร";
      }

      if (blocks.includes("tax")) {
        if (!f.tax.calendarYear) return "Please enter Calendar Year | กรุณากรอกปีภาษี";
        if (!/^\d{4}$/.test(f.tax.calendarYear))
          return "Calendar Year must be YYYY | ปีภาษีต้องเป็นตัวเลข 4 หลัก";
        if (!f.tax.filingDate) return "Please enter Filing Date | กรุณากรอกวันที่ยื่น";
      }

      if (blocks.includes("simple") && !f.simple.issueDate)
        return "Please enter Issue Date | กรุณากรอกวันที่ออกเอกสาร";

      if (blocks.includes("cancel")) {
        if (!f.cancel.submissionDate) return "Please enter Submission Date | กรุณากรอกวันที่ยื่นขอยกเลิก";
        if (!f.cancel.effectiveDate) return "Please enter Effective Date | กรุณากรอกวันที่มีผลจริง";
      }

      return null; // ผ่านหมด
    },
  },
};
